var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { getDatumKey } from './getDatumKey';
/**
 * sory by name and groupName property `[name] - [groupName]`
 * if groupName is undefined, sort by name only
 */
export function sortByName(data) {
    return __spreadArray([], data).sort(function (a, b) {
        if (getDatumKey(a).toLowerCase() < getDatumKey(b).toLowerCase())
            return -1;
        if (getDatumKey(b).toLowerCase() < getDatumKey(a).toLowerCase())
            return 1;
        return 0;
    });
}
/**
 * sort be name and groupName accessor return values - same as above,
 * only doesn't require known named properties `name` and `groupName`
 */
export function sortSeriesByName(data, accessors) {
    return __spreadArray([], data).sort(function (a, b) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((accessors.name(a) + " " + ((_b = (_a = accessors === null || accessors === void 0 ? void 0 : accessors.group) === null || _a === void 0 ? void 0 : _a.call(accessors, a)) !== null && _b !== void 0 ? _b : '')).toLocaleLowerCase() <
            (accessors.name(b) + " " + ((_d = (_c = accessors === null || accessors === void 0 ? void 0 : accessors.group) === null || _c === void 0 ? void 0 : _c.call(accessors, b)) !== null && _d !== void 0 ? _d : '')).toLocaleLowerCase())
            return -1;
        if ((accessors.name(a) + " " + ((_f = (_e = accessors === null || accessors === void 0 ? void 0 : accessors.group) === null || _e === void 0 ? void 0 : _e.call(accessors, a)) !== null && _f !== void 0 ? _f : '')).toLocaleLowerCase() >
            (accessors.name(b) + " " + ((_h = (_g = accessors === null || accessors === void 0 ? void 0 : accessors.group) === null || _g === void 0 ? void 0 : _g.call(accessors, b)) !== null && _h !== void 0 ? _h : '')).toLocaleLowerCase())
            return 1;
        return 0;
    });
}
//# sourceMappingURL=sortByName.js.map